import { get, API_URL } from '../utils/api';

const LEVY_COLLECTION_BASE_URL = `${API_URL}/java/cxf/uns/levy-collection-fee`;

/**
 * Fetch the active levy collection for a unit.
 *
 * @param {string} unitUuid - Unit UUID with dashes
 * @returns {Promise<Object|null>} Active levy collection or null
 */
export const getCurrentLevyCollection = async (unitUuid) => {
  if (!unitUuid) return null;

  try {
    const response = await get(`${LEVY_COLLECTION_BASE_URL}/current/unit/${unitUuid}`);
    return response.data || null;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    // console.error('Error fetching current levy collection:', error);
    return null;
  }
};

/**
 * Fetch levy allocation history for a unit.
 *
 * @param {string} unitUuid - Unit UUID with dashes
 * @returns {Promise<Array>} Allocation rows
 */
export const getLevyAllocationsForUnit = async (unitUuid) => {
  if (!unitUuid) return [];

  try {
    const response = await get(`${LEVY_COLLECTION_BASE_URL}/allocations/unit/${unitUuid}`);
    const data = response.data;

    if (Array.isArray(data)) {
      return data;
    }

    return data?.allocations || [];
  } catch (error) {
    // console.error('Error fetching levy allocation history:', error);
    return [];
  }
};
